import { getRequest, postRequest } from "app/axiosClient";
import {
  showLoader,
  hideLoader,
} from "CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import {
  setProductsRecords,
  setProductDetails,
} from "./ProductsandServicesSlice";
import { uploadAttachment } from "CommonComponents/Attachments/AttachmentsAPI";

export const getProductsServicesAPI = (input) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/ProductService/GetProducts`, input)
      .then((res) => {
        dispatch(setProductsRecords(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          errorMessage,
          "ProductService.Notification.Pleasetryagainafterawhile"
        );
      });
  } catch {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "ProductService.Notification.AnunexpedtederrorwhileretrievingProducts"
    );
  }
};

export const addProductsServicesAPI = (input) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/ProductService/UpsertProduct`, input)
      .then((res) => {
        dispatch(setProductsRecords(res?.data));
        dispatch(uploadAttachment(res?.data));
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "ProductService.Notification.Productserviceaddedsuccessfully"
        );
        return true;
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon("error", "Common.Error", errorMessage, "");
        return false;
      });
  } catch {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "ProductService.Notification.Anunexpectederrorwhileaddingproducts"
    );
    return false;
  }
};

export const getProductByIdAPI = (id) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/ProductService/GetProductById?productId=${id}`)
      .then((res) => {
        dispatch(setProductDetails(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          errorMessage,
          "ProductService.Notification.Pleasetryagainafterawhile"
        );
      });
  } catch {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "ProductService.Notification.Anunexpectederroroccuredwhileretrievingproductdetails"
    );
  }
};
export const ValidateBulkProductServiceApi = (inputRequest) => (dispatch) =>
  new Promise((resolve, reject) => {
    try {
      postRequest(`api/ProductService/ValidateBulkUpload`, inputRequest)
        .then((res) => {
          dispatch(hideLoader());
          resolve(res);
        })
        .catch((e) => {
          dispatch(hideLoader());
          reject(e);
        });
    } catch (e) {
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "ProductService.Notification.Anunexpectederroroccuredwhilevalidatingfile"
      );
    }
  });

export const UploadBulkProductServiceApi = (inputRequest) => (dispatch) =>
  new Promise((resolve, reject) => {
    try {
      postRequest(`api/ProductService/SubmitUpload`, inputRequest)
        .then((res) => {
          const pagination = {
            pageNo: null,
            pageSize: 10,
            searchQuery: "",
          };
          dispatch(getProductsServicesAPI(pagination));
          resolve(res);
        })
        .catch((e) => {
          dispatch(hideLoader());
          reject(e);
        });
    } catch (e) {
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "ProductService.Notification.Anunexpectederroroccuredwhileuploadingfile"
      );
    }
  });
export const GetProductServiceTemplateApi = () =>
  getRequest(`api/ProductService/ExportProductsToExcel`, {
    responseType: "blob",
  });
